/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  AbandonedCheckout,
  AbandonedCheckoutDetail,
  GetAdminV1StoresStoreIdCheckouts200,
  GetAdminV1StoresStoreIdCheckoutsIdPathParameters,
  GetAdminV1StoresStoreIdCheckoutsParams,
  GetAdminV1StoresStoreIdCheckoutsPathParameters,
  PostAdminV1StoresStoreIdCheckoutsIdSendRecoveryPathParameters
} from '../model';

import { customInstance } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Checkouts that reached the address step and went quiet past settings.checkout.abandonmentMinutes; recovered ones carry the order they became. canSendRecovery says whether send-recovery would succeed right now
 * @summary Abandoned checkouts, newest first
 */
export const getAdminV1StoresStoreIdCheckouts = (
    { storeId }: GetAdminV1StoresStoreIdCheckoutsPathParameters,
    params?: GetAdminV1StoresStoreIdCheckoutsParams,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdCheckouts200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdCheckouts200>(
      {url: `/admin/v1/stores/${storeId}/checkouts`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary One stalled checkout with its lines, addresses, totals and recovery history
 */
export const getAdminV1StoresStoreIdCheckoutsId = (
    { storeId, id }: GetAdminV1StoresStoreIdCheckoutsIdPathParameters,
 options?: SecondParameter<typeof customInstance<AbandonedCheckoutDetail>>,) => {
      return customInstance<AbandonedCheckoutDetail>(
      {url: `/admin/v1/stores/${storeId}/checkouts/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * 409 with meta.reason (template_disabled, expired, completed, incomplete) exactly when the list reports canSendRecovery false
 * @summary Send (or resend) the recovery email now
 */
export const postAdminV1StoresStoreIdCheckoutsIdSendRecovery = (
    { storeId, id }: PostAdminV1StoresStoreIdCheckoutsIdSendRecoveryPathParameters,
 options?: SecondParameter<typeof customInstance<AbandonedCheckout>>,) => {
      return customInstance<AbandonedCheckout>(
      {url: `/admin/v1/stores/${storeId}/checkouts/${id}/send-recovery`, method: 'POST'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdCheckoutsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdCheckouts>>>
export type GetAdminV1StoresStoreIdCheckoutsIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdCheckoutsId>>>
export type PostAdminV1StoresStoreIdCheckoutsIdSendRecoveryResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdCheckoutsIdSendRecovery>>>
